import { constants } from "@qgiv/core-js";

const {
    ENUMS: { DisplayOn },
} = constants;

export const defaultConfig = {
    currentDisplay: DisplayOn.FRONTEND,
};
